import { render, staticRenderFns } from "./DialogoActividad.vue?vue&type=template&id=1a854b61&lang=pug&"
import script from "./DialogoActividad.vue?vue&type=script&lang=js&"
export * from "./DialogoActividad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports